// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"38953eae","511":"7135c159","767":"2d339735"}[chunkId] + ".chunk.js";
};